export const content = {
  links: [{ title: "Home", link: "/" }],
  contact: [
    { icon: "phone", link: "tel:+353831166159", title: "+353 83 116 6159" },
    {
      icon: "email",
      link: "mailto:adernerprojectstudio@gmail.com",
      title: "adernerprojectstudio@gmail.com",
    },
  ],
  socials: [
    { icon: "facebook", link: "" },
    { icon: "linkedin", link: "" },
    { icon: "twitter", link: "" },
  ],
}
